"use client";

import { useEffect } from "react";

import { hapticLight } from "@/lib/haptics";

/**
 * Delegated haptics on primary pointer down for common interactive targets app-wide.
 * Opt out: `data-no-haptic` on an element or ancestor.
 */
export function GlobalHaptics() {
  useEffect(() => {
    const selector = [
      "button",
      "a[href]",
      '[role="button"]',
      "[data-haptic]",
      'input[type="button"]',
      'input[type="submit"]',
      'input[type="reset"]',
      'input[type="checkbox"]',
      'input[type="radio"]',
      'input[type="range"]',
      "label",
      "select",
      "summary",
    ].join(",");

    const onPointerDown = (e: PointerEvent) => {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      const target = e.target;
      if (!(target instanceof Element)) return;
      const el = target.closest(selector);
      if (!el) return;
      if (el.closest("[data-no-haptic]")) return;

      if (el instanceof HTMLButtonElement && el.disabled) return;
      if (el instanceof HTMLInputElement && el.disabled) return;
      if (el instanceof HTMLSelectElement && el.disabled) return;
      if (el.getAttribute("aria-disabled") === "true") return;

      hapticLight();
    };

    document.addEventListener("pointerdown", onPointerDown, { capture: true });
    return () => document.removeEventListener("pointerdown", onPointerDown, { capture: true });
  }, []);

  return null;
}
